// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__NnsfT","name":"Header_name__a5Zwy","birthday":"Header_birthday__2U5NC","skeleton":"Header_skeleton__2JmiE"};